var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseMobileModal = function SvgCloseMobileModal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F8F5F2",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A3847",
    d: "M19.868 11.205 16 15.072l-3.867-3.867-.928.928L15.073 16l-3.868 3.867.928.928L16 16.927l3.868 3.868.927-.928L16.928 16l3.867-3.867z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseMobileModal);
export default ForwardRef;